import { HttpAgent } from '@dfinity/agent'
import { Principal } from '@dfinity/principal'
import { Chain } from './common'

export enum SwapMode {
  BUY = 'buy',
  SELL = 'sell',
}

export enum SwapProvider {
  ICPSWAP = 'ICPSwap',
  KONGSWAP = 'KongSwap',
  ODIN = 'Odin',
}

export interface SwapInfo {
  quote: number
  slippage?: number
}

export interface SwapTokenPair {
  swapCanisterPrincipal: string
  feeRate: number
  token0: {
    principal: string
    standard: string
  }
  token1: {
    principal: string
    standard: string
  }
  provider: SwapProvider
  paused: boolean
  unitSize?: number
}

export interface SwapPairInfo {
  unitSize: number
  paused: boolean
}

export interface DepositAddress {
  owner: Principal
  subaccount: [] | [Uint8Array | number[]]
  accountId: string
  txId: string
  nonce: number
}

export interface TokenChange {
  debitValue: number
  creditValue: number
}

export interface OrderFill {
  time: Date
  token0Change: TokenChange
  token1Change: TokenChange
}

export interface SwapEvent {
  id: string
  txId: string
  status: string
  from?: SwapHistoryTokenType
  to?: SwapHistoryTokenType
  timestamp: number
  swapPairCanisterPrincipal: string
}

export interface SwapHistoryTokenType {
  canisterId: string
  amount: number
}

export interface SwapStatus {
  status: string
  fill?: OrderFill
  token0?: string
  token1?: string
}

export interface SwapSourceToken {
  principal: string
  standard: string
  fee: number
}

export enum SwapStep {
  Transfer = 'transfer',
  Approve = 'approve',
  Deposit = 'deposit',
  Swap = 'swap',
  Withdraw = 'withdraw',
  ErrorFallback = 'errorFallback',
}

export interface InputError {
  inputFieldError?: string
  buttonError: string
}

export interface ExchangeToken {
  chain?: Chain
  id: string
  symbol: string
  logo: string
  name: string
  standard: string
}

export interface SwapInterface<TokenType> {
  agent: HttpAgent
  getPairs: () => Promise<SwapTokenPair[]>
  getPair: (from: TokenType, to: TokenType) => Promise<SwapTokenPair | undefined>
  getDepositAddress: (
    swapCanisterPrincipal: string,
    principal: Principal
  ) => Promise<DepositAddress>
  getQuote: (swapCanisterPrincipal: string, mode: SwapMode, amount: number) => Promise<SwapInfo>
  swap: (
    swapCanisterPrincipal: string,
    mode: SwapMode,
    fromToken: TokenType,
    toToken: TokenType,
    amount: number,
    limitPrice: number,
    maxSlippage: number,
    setStep: (step: SwapStep) => void
  ) => Promise<number>
  getSwapPairEvents: (
    swapPairCanisterPrincipal: string,
    accountPrincipal: string
  ) => Promise<SwapEvent[]>
  fallback: (swapCanisterPrincipal: string, subaccount: number[]) => Promise<Boolean>
}
